export default "__VITE_ASSET__DS_KQ09F__"